export function Al(promise) {
    return promise
        .then(data => {
            return data
        })
        .catch(error => error);
}
